import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';

import { getData } from 'utils/dynamicData';
import { joinClasses } from 'utils/utils';

import PageLink from 'components/pageLink/pageLink';
import ShareIcons from 'components/shareIcons/shareIcons';

import { capitalize } from 'helpers/misc';

import s from 'components/footer/footer.sss';

// Should this be based on build date or current date?
// Probably build date: https://stackoverflow.com/a/2391555/1336843
const copyrightDate = (typeof window !== 'undefined' ? new Date(window.__BUILD_DATE__) : new Date()).getFullYear();

export default class Footer extends Component {

	constructor(props) {
		super(props);
		this.state = {
			links: [],
			legal: [],
		};

		this.onAnyClick = this.onAnyClick.bind(this);
		this.renderLink = this.renderLink.bind(this);

		if (typeof window !== 'undefined') {
			this.loadData();
		}
	}

	async loadData() {
		try {
			const data = await getData('navigation');
			const links = (data?.footer?.links || []).map(section => (section || []).filter(e => e)).filter(e => e);
			const legal = (data?.footer?.legal || []).filter(e => e);
			this.setState({ links, legal });
		} catch (err) {
			console.error(err);
		}
	}

	onAnyClick(e) {
		// close on internal navigation
		const link = e.target.closest('a');
		if (!link) return;

		let href = link.getAttribute('href');
		if (href) {
			let label = link.innerHTML;
			if (link instanceof HTMLElement) {
				label = link.innerText || link.textContent || '';
			}
			if (label) {
				this.trackNavLinkClick(label, href);
			}
		}
	}

	trackNavLinkClick(label, path) {
		Store.emit(actions.FOOTER_PERSISTENT_BUTTON_CLICK, label);
	}

	renderDoNotSellLogo() {
		const imageRoot = Store.get().appData?.urls?.roots?.studio || '';
		return <img class={s.doNotSellLogo} src={imageRoot + '/images/ccpa-icon/privacyoptions.svg'} alt="California Consumer Privacy Act (CCPA) Opt-Out Icon" />;
	}

	renderLink(link, type) {
		if (typeof link === 'string') {
			link = { name: Store.get().appData.pages[link]?.name || link, destination: link };
		}
		if (!link?.name) return;
		if (!link.destination) {
			return <span>{link.name}</span>;
		}
		if (/OneTrust\.ToggleInfoDisplay/.test(link.destination)) {
			const { client, appData } = Store.get();
			const clientGeo = client?.geo;
			const appRegion = appData?.meta?.region?.slug;
			let name = link.name;
			if (clientGeo?.countryCode && (clientGeo?.countryCode !== appRegion)) {
				name = 'Cookie Notice';
			}
			return (
				<div class={s.link} onClick={() => window.OneTrust?.ToggleInfoDisplay()}>
					{(clientGeo?.countryCode === appRegion) && this.renderDoNotSellLogo()}
					{name}
				</div>
			);
		}
		if (/^https?:\/\//i.test(link.destination)) {
			return <a href={link.destination} target="_blank" rel="noopener noreferrer" onClick={() => type === 'legal' ? Store.emit(actions.FOOTER_LEGAL_CLICK, { label: link.name, path: link.destination }) : null}>{link.name}</a>;
		}
		return <PageLink to={link.destination} onClick={()=> Store.emit(actions.FOOTER_NAV_CLICK, capitalize(link.name?.toLowerCase()))}>{link.name}</PageLink>;
	}

	render(props, state) {
		return (
			<footer class={s.wrapper} onClickCapture={this.onAnyClick}>
				<div class={s.content}>
					<div class={s.main}>
						<div class={s.logo}>
							<img src={`${__IMAGE_ROOT__}/logo.svg`} width="79" height="40" alt="Universal Logo" />
						</div>
						<div class={s.linksWrapper}>
							{state.links.map(section => (
								<div class={joinClasses(s.section, s.links)}>
									{section.map(this.renderLink)}
								</div>
							))}
						</div>
						<div class={s.shareWrapper}>
							<ShareIcons class={s.share} id="footer" />
						</div>
					</div>
					<div class={s.legal}>
						{state.legal.map(link => this.renderLink(link, 'legal'))}
					</div>
					<div class={s.copyright}>© {copyrightDate} Universal Pictures</div>
				</div>
			</footer>
		);
	}

}